import { AlphaUIcon } from './AlphaUIcon';

/**
 * author: GreenTurtwig
 * id 7404138B-11FC-441F-9F64-2CADF3EED84F
 * name alpha-u
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-u.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetUIcon = AlphaUIcon;
export default AlphabetUIcon